<template>
    <DCard
        padding
        :title="$t('certificate_import.title')"
    >
        <DCol>
            <DFormRow
                class="mt-2"
                label=""
                :error="form.errors.duplicateHandling"
            >
                <DRadioGroup
                    id="duplicateHandling"
                    v-model="form.duplicateHandling"
                    inline
                    :options="[
                        { value: 'skip-duplicates', label: $t('certificates.duplicate_handling_skip')},
                        { value: 'overwrite', label: $t('certificates.duplicate_handling_overwrite')},
                    ]"
                />
            </DFormRow>
            <DFormRow
                :label="$t('certificate_import.file_label')"
                is-required
                :error="form.errors.file"
                :hint="form.file ? form.file.name : ''"
            >
                <DFileInput
                    @change="addFile"
                />
            </DFormRow>
            <DFormRow
                label=""
                class="mb-3"
            >
                <DButton
                    :label="$t('certificate_import.template_button')"
                    color="secondary"
                    @click="downloadTemplate"
                />
            </DFormRow>
            <DFormRow
                label=""
                class="mb-0"
            >
                <p>{{ $t('certificate_import.csv_delimiter_hint') }}</p>
            </DFormRow>
        </DCol>
        <DFabs>
            <DFab
                icon="content-save"
                :label="$t('common.save')"
                @click="submitForm"
            />
        </DFabs>
    </DCard>
</template>

<script>
import { useForm } from '@inertiajs/vue3'

export default {
    name: 'CertificatesImport',
    data () {
        return {
            form: useForm({
                duplicateHandling: 'skip-duplicates',
                file: null
            })
        }
    },
    methods: {
        submitForm () {
            this.form.post(this.$route('certificates.import.upload'))
        },
        addFile (fileList) {
            this.form.file = fileList[0]
        },
        downloadTemplate () {
            const link = document.createElement('a')
            link.href = this.$route('certificates.import.download-template')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
    }
}
</script>

<style scoped>

</style>
